import { body1 } from '../typography';
import palette from '../palette';
import theme from '../default';

export default {
    root: {
        color: palette.text.secondary,
        ...body1,
    },
    input: {
        '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
            animationDuration: '0ms',
        },
        '&:autofill, &:autofill:hover, &:autofill:focus': {
            animationDuration: '0ms',
        },
    },
    adornedEnd: {
        '& .MuiSelect-icon + .MuiInputAdornment-positionEnd': {
            marginRight: theme.spacing(2),
        },
    },
};
